<template>
  <div class="use-cases">

    <div data-aos="fade-zoom-in"
         data-aos-delay="200"
         data-aos-easing="ease-in"
         data-aos-duration="600"
         class="container">
      <div id="dots-use-cases" class="dots-large"></div>

      <div class="heading-container">
        <h1>Use Cases</h1>
        <div class="arrow-down">
          <img data-aos="fade-zoom-in"
               data-aos-delay="100"
               data-aos-easing="ease-in"
               data-aos-duration="400"
               data-aos-anchor-placement="top-bottom"
               src="@/assets/img/angle-double-down.svg">
        </div>
      </div>
    </div>

    <use-case></use-case>
  </div>
</template>

<script>
import UseCase from '../components/UseCase'

export default {
  name: 'UseCases',
  components: { UseCase },
  mounted () {
    window.addEventListener('scroll', function () {
      const height = window.innerHeight
      const useCases = document.getElementsByClassName('use-cases').item(0)
      let dots = document.getElementById('dots-use-cases')

      if (!dots || !useCases) {
        return;
      }

      if (window.scrollY > height / 4) {
        useCases.classList.add('change-color')
        dots.classList.add('change-opacity')
      }

      if (window.scrollY < height / 4) {
        useCases.classList.remove('change-color')
        dots.classList.remove('change-opacity')
      }
    })
  }
}
</script>

<style scoped lang="scss">
  .use-cases {
    background: $background-dark;
    color: $text-light;
    transition: 1s all;
  }

  span {
    font-size: 24px;
  }

  .container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 56px;
    margin-top: -100px;
    color: $text-grey;

    .arrow-down {
      width: 100%;
      height: 92px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        filter: invert(0.8) opacity(0.8);
        margin-top: 48px;
        width: 64px;
      }
    }
  }

  .change-color {
    background-color: #eeeeee !important;
    color: $text-dark !important;
  }
</style>
